// =========================================================
// * Vue Material Dashboard - v1.2.1
// =========================================================
//
// * Product Page: https://www.creative-tim.com/product/vue-material-dashboard
// * Copyright 2019 Creative Tim (https://www.creative-tim.com)
// * Licensed under MIT (https://github.com/creativetimofficial/vue-material-dashboard/blob/master/LICENSE.md)
//
// * Coded by Creative Tim
//
// =========================================================
//
// * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import VueRouter from "vue-router";
import App from "./App";

// router setup
import routes from "./routes/routes";

// Plugins
import GlobalComponents from "./globalComponents";
import GlobalDirectives from "./globalDirectives";
import Notifications from "./components/NotificationPlugin";

import VueApexCharts from 'vue-apexcharts'


// MaterialDashboard plugin
import MaterialDashboard from "./material-dashboard";
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'native-toast/dist/native-toast.css'
import Chartist from "chartist";

import store from './store'
import firebase from 'firebase'
// import JsonExcel from 'json-to-excel';
import JsonCSV from 'vue-json-csv'
 
Vue.component('downloadCsv', JsonCSV)
// configure router
const router = new VueRouter({
  routes, // short for routes: routes
  linkExactActiveClass: "nav-item active"
});

Vue.prototype.$Chartist = Chartist;
Vue.use(BootstrapVue)

Vue.use(VueRouter);
Vue.use(MaterialDashboard);
Vue.use(GlobalComponents);
Vue.use(GlobalDirectives);
Vue.use(Notifications);
Vue.use(VueApexCharts)
Vue.component('apexchart', VueApexCharts)
// Vue.component('downloadExcel', JsonExcel);
router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(x => x.meta.requiresAuth)
   //console.log(Vals) requiresAuth &&requiresAuth &&
  if ( requiresAuth &&  !localStorage.getItem("authedUser")) {
    
      next('/')
  } else if (requiresAuth && localStorage.getItem("authedUser")) {
      next()
  } else {
      next()
  }
})

var firebaseConfig = {
  apiKey: "AIzaSyBpKT1PRGt7QOygpSsnF4PxQ_tF6iXTfqM",
  authDomain: "provider-admin-panel.firebaseapp.com",
  databaseURL: "https://provider-admin-panel.firebaseio.com",
  projectId: "provider-admin-panel",
  storageBucket: "provider-admin-panel.appspot.com",
  messagingSenderId: "799936284058",
  appId: "1:799936284058:web:209f3e1516bdc42bec6623",
  measurementId: "G-741JE0Q18G"
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);
firebase.analytics();
window.firebase = firebase;

/* eslint-disable no-new */
new Vue({
  el: "#app",
  render: h => h(App),
  router,
  firebase,
  store,
  data: {
    Chartist: Chartist
  }
});
